// Models
import { Insuree } from "app/_models/insuree.model";
import { PolicyControl } from "app/_models/policycontrol.model";
import { CaseModel } from "./case.model";
import { HelpPlanDetailsModel } from "./helpPlanDetails.model";
import { FellowTraveller } from './fellow-traveller.model';
import { TravelDetailModel } from "./travel-detail.model";
import { LocationDetailsModel } from "./location_details.model";
import { SummaryDetailsModel } from "./summary-details.model";
import { DossierNoteModel } from "app/intake/note/models/dossier-note.model";
import { RehospitalisationModel } from "app/intake/rehospitalisation/models/rehospitalisation.model";
import { AdlModel } from "app/intake/adl/models/adl.model";
import { DbcModel } from "app/intake/dbc/models/dbc.model";
import { DossierModel } from "./Dossier.model";
import { PureCloudInfo } from "./pureCloudInfo";
import { InsureeData } from "./insuree-data.model";

export class IntakeDataModel {
  draftDossierNumber :string = null;
  intakeDuration: string = null;
  dossierStatus: string = null;
  policy: PolicyControl = null;
  insuree: Insuree = null;
  adl: AdlModel = null;
  dbc: DbcModel = null;
  case: CaseModel = null;
  cases: CaseModel[] = [];
  travels: TravelDetailModel[] = [];
  travel: TravelDetailModel = null;
  helpPlans: HelpPlanDetailsModel[] = [];
  parties: FellowTraveller[] = [];
  locations: LocationDetailsModel[] = [];
  summary: SummaryDetailsModel = new SummaryDetailsModel();
  dossierId: string = null;
  assignmentId: string = null;
  notes: DossierNoteModel; 
  rehospitalisation: RehospitalisationModel = null;
  userName: string;
  creationDate: string;
  roles: string[] = [];
  linkedDossiers: DossierModel[] = [];
  originalDossierId: string =null;
  isCopy: boolean = false;
  changeCaseType: boolean = false;
  pureCloudInfo: PureCloudInfo = null;
  isUrgent : boolean = false;
  insureeData: InsureeData = null;
  userEmail: string = null;
  sspCount: number = 0;
}